export const COMMONS_ROUTES = {
  LOGIN: "/",
  MENU: "/menu",
  NUEVO_USUARIO: "/nuevo-usuario",
  MODIFICAR_USUARIO: "/modificar-usuario",
  MODIFICAR_CONTRASENA: "/modificar-contrasena",
};
